import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-5 gap-3" }
const _hoisted_2 = { class: "border px-2 py-1 rounded bg-white" }
const _hoisted_3 = { class: "border px-2 py-1 rounded bg-white" }
const _hoisted_4 = { class: "border px-2 py-1 rounded bg-white" }
const _hoisted_5 = { class: "border px-2 py-1 rounded bg-white" }
const _hoisted_6 = { class: "border px-2 py-1 rounded bg-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, "BP: " + _toDisplayString(_ctx.budgetProgetto), 1),
    _createElementVNode("span", _hoisted_3, "TC: " + _toDisplayString(_ctx.totaleCosti), 1),
    _createElementVNode("span", _hoisted_4, "PM: " + _toDisplayString(_ctx.primoMarigne), 1),
    _createElementVNode("span", _hoisted_5, "PM: " + _toDisplayString(_ctx.primoMarignePerc), 1),
    _createElementVNode("span", _hoisted_6, "F: " + _toDisplayString(_ctx.fee), 1)
  ]))
}